export const SET_PAYMENT_STARTED = 'setPaymentStarted';
export const GET_PAYMENT_STARTED = 'getPaymentStarted';
export const FIND_PAYMENT_STARTED = 'findPaymentStarted';

export const SET_VALUES = 'setValues';
export const GET_VALUES = 'getValues';
export const SET_DISABLED_METHODS_PAYMENT = "setDisabledMethodsPayment"
export const GET_DISABLED_METHODS_PAYMENT = "getDisabledMethodsPayment"
